export interface AccessRequestCreateBody {
  email: string;
  orgName?: string;
}

import { getApiBaseUrl } from '../config';

const API_BASE = getApiBaseUrl(
  import.meta.env.VITE_ACCESS_ADMIN_API_URL ??
  import.meta.env.VITE_API_BASE_URL ??
  'http://localhost:4000'
);

export async function requestAccess(body: AccessRequestCreateBody): Promise<void> {
  const url = `${API_BASE.replace(/\/$/, '')}/api/access-requests`;

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });

  if (!res.ok) {
    let message = 'Failed to submit request';
    try {
      const text = await res.text();
      if (text) {
        message = text;
      } else {
        message = `Failed to submit request: ${res.status} ${res.statusText}`;
      }
    } catch {
      message = `Failed to submit request: ${res.status} ${res.statusText}`;
    }
    throw new Error(message);
  }
}
